<!--  -->
<template>
  <div class="div_ucDriveRouteLine">

    <el-tabs
      v-model="ucSetting.tabIndex"
      type="card"
      class="el-tabs-routeDrive"
      @tab-click="_tabClickHandler"
    >
      <el-tab-pane
        v-for="styleItem in driveStyles"
        :key="styleItem.id"
        :label="styleItem.label"
        :name="styleItem.id"
      >

        <div class="div_content">
          <div
            class="div_startPOIName"
            v-show="distanceDesc"
          >
            {{distanceDesc}}
          </div>

          <span
            v-show="startPOIName"
            class="span_endPoint"
          >
            <i class="i_viaPOISuggest"></i>
            {{startPOIName}}
          </span>

          <el-collapse>

            <div
              v-for="(simpleItem,collapseIndex) in simpleItems"
              :key="simpleItem.id"
              @click="_collapseItemClickHandler(simpleItem,collapseIndex)"
            >

              <el-collapse-item>
                <template slot="title">
                  <li>

                    <span class="span_segmentItemSN">{{collapseIndex+1}}.</span>
                    <span> {{simpleItem.strguide}}</span>
                  </li>
                </template>

                <li
                  class="li_rangeRouteItem"
                  v-for="(item,itemIndex) in rangeRouteItems[collapseIndex]"
                  :key="item.id"
                >
                  <span>{{itemIndex+1}})</span>
                  <span>{{item.strguide}}</span>

                </li>
              </el-collapse-item>
            </div>

          </el-collapse>

          <span
            v-show="endPOIName"
            class="span_endPoint"
          >
            <i class="i_endPOISuggest"></i>
            {{endPOIName}}
          </span>
        </div>

      </el-tab-pane>

    </el-tabs>

  </div>
</template>

<script>
import { RouteFilter, RouteSearchResult } from "../model/Route.js";
import { DriveStyle } from "../../../utility/tdtService/Drive/Model/DriveStyle.js";
// import { DriveRouteInfo } from "../../../utility/tdtService/Drive/Model/DriveRouteInfo.js";
import {
  RouteSearchType,
  UCRouteConstant,
  UCRouteEvent,
  RoutePOIInfo
} from "./UCRouteJs.js";

export default {
  name: "UCDriveRouteLine",
  data() {
    return {
      ucSetting: {
        tabIndex: 0
      },

      //换乘类型
      transferType: DriveStyle.LeastTime,

      //搜索参数
      searchParams: null,

      //驾车类型数组
      driveStyles: UCRouteConstant.driveStyles,

      //简单项集合
      simpleItems: new Array(),

      //线路项区间集合，与simpleItems一一对应
      rangeRouteItems: new Array(),

      //线路信息
      routeInfo: null,

      //距离描述
      distanceDesc: null,

      //起点poi名称
      startPOIName: null,

      //终点poi名称
      endPOIName: null
    };
  },

  components: {},

  computed: {},

  mounted() {},

  methods: {
    /**
     * 初始化
     */
    init() {
      if (this.searchParams) {
        this._searchRouteLine();
        this.startPOIName = this.searchParams.startPoint.POI.name;
        this.endPOIName = this.searchParams.endPoint.POI.name;
      } else {
        this.startPOIName = null;
        this.endPOIName = null;
      }

      this.simpleItems = new Array();
    },
    //绑定线路搜索完成事件
    on_routeSearchFinished(callback) {
      this.$on(UCRouteEvent.UCDriveRouteLine_routeSearchFinished, callback);
    },

    //绑定单个线路项单击事件
    on_routeItemClick(callback) {
      this.$on(UCRouteEvent.UCDriveRouteLine_routeItemClick, callback);
    },

    /**
     * 单个tab也页单击
     */
    _tabClickHandler(tab, event) {
      if (!tab) return;

      let tabIndex = parseInt(tab.index);
      if (tabIndex === 0) {
        this.transferType = DriveStyle.LeastTime;
      } else if (tabIndex === 1) {
        this.transferType = DriveStyle.LeastDistance;
      } else if (tabIndex === 2) {
        this.transferType = DriveStyle.AvoidHighways;
      }

      this._searchRouteLine();
    },

    //线路搜索
    _searchRouteLine() {
      let self = this;
      let filter = new RouteFilter();
      filter.startPositionX = this.searchParams.startPoint.POI.x;
      filter.startPositionY = this.searchParams.startPoint.POI.y;
      filter.endPositionX = this.searchParams.endPoint.POI.x;
      filter.endPositionY = this.searchParams.endPoint.POI.y;
      filter.driveViaCoorString = RoutePOIInfo.getViaPointCoorString(
        this.searchParams.driveViaPoints
      );

      //筛选类型
      filter.filterType = RouteSearchType.national_drive;
      filter.transferType = this.transferType;

      RouteSearchResult.search(
        filter,
        function(response) {
          self.routeInfo = response.resultObject;
          self.simpleItems = self.routeInfo.simple.objects;
          self.rangeRouteItems = self.routeInfo.getRouteItemRanges();
          self.distanceDesc = "总里程:约" + self.routeInfo.distance + "公里";

          //触发事件
          self.$emit(
            UCRouteEvent.UCDriveRouteLine_routeSearchFinished,
            self.routeInfo
          );
        },
        function(erorr) {}
      );
    },

    //单个线路项单击事件
    _collapseItemClickHandler(routeItem, collapseIndex) {
      let self = this;

      //触发事件
      self.$emit(UCRouteEvent.UCDriveRouteLine_routeItemClick, routeItem);
    }
  }
};
</script>

<style lang="scss" scoped >
// @import "../../../assets/styles/elcollapse.scss";
// @import "../../../assets/styles/elTabs.scss";

.div_ucDriveRouteLine {
  padding: 5px 19px 5px 30px;
  font-size: 12px;

  .div_content {
    padding: 0px 0px 0px 0px;
    text-align: left;
  }

  .span_endPoint {
    display: flex;
    padding: 5px;
  }

  .div_startPOIName {
    background: #f0f7ff;
    padding: 10px;
  }

  .span_segmentItemSN {
    color: #2f87eb;
  }

  .i_viaPOISuggest {
    background: url("../../../assets/onlineMap/icon.png") #fff;
    background-repeat: no-repeat;
    display: inline-block;
    width: 16px;
    height: 16px;

    background-position: -512px -154px;
  }

  .i_endPOISuggest {
    background: url("../../../assets/onlineMap/icon.png") #fff;
    background-repeat: no-repeat;
    display: inline-block;
    background-position: -536px -154px;
    width: 16px;
    height: 16px;
  }

  .li_rangeRouteItem {
    margin: 0;
    padding: 0;
    list-style: none;
    line-height: 22px;
    margin-left: 10px;
  }
}

/deep/ .el-tabs-routeDrive {
  height: 100%;

  .el-tabs__header {
    padding: 0;
    position: relative;
    margin: 0 0 5px;
  }

  .el-tabs__item {
    font-size: 12px;
    height: 26px;
    line-height: 26px;
  }

  .el-tabs__content {
    height: 80%;
    flex-grow: 1;
    overflow-y: auto;

    .el-tab-pane {
      height: 100%;
    }
  }
}

/deep/.el-collapse {
  border-top: none;
  border-bottom: none;
  padding: 5px 10px;

  .el-collapse-item {
    padding-bottom: 5px;

    .el-collapse-item__content {
      font-size: 12px;
    }

    .el-collapse-item__header {
      //修改高度为32
      height: 100%;
      line-height: 32px;

      //修改字体
      font-size: 12px;
      //修改颜色
      color: #000;

      background-color: #fff;

      .el-collapse-item__arrow {
        display: none;
      }
    }
  }
}
</style>
